import { LogLevel } from "@azure/msal-browser";

// Always use current origin for redirectUri so it matches the loaded host
const getRedirectUri = () => {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin;
  }
  // Fallback for non-browser environments
  return 'http://localhost:3000';
};

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AAD_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AAD_TENANT}`,
        redirectUri: getRedirectUri(),
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

// Scopes for initial ID token (Graph not required for our app); keep minimal
export const loginRequest = {
    scopes: ["openid", "profile", "email"]
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

// Environment-based API endpoint (allow override via env)
const getApiEndpoint = () => {
  const fromEnv = process.env.REACT_APP_API_BASE_URL;
  if (fromEnv && fromEnv.trim().length > 0) return fromEnv.replace(/\/$/, '') + '/api';
  if (process.env.NODE_ENV === 'production') {
    // In production, use same-origin relative base
    return '/api';
  }
  // Default to HTTPS dev backend to avoid CORS redirect issues
  return 'https://localhost:7040/api';
};

// Scopes for access token to be used at your API endpoints.
export const apiRequest = {
    scopes: [process.env.REACT_APP_API_SCOPE || process.env.REACT_APP_API_AUDIENCE || ""].filter(Boolean),
    apiEndpoint: getApiEndpoint()
};
